import { render, staticRenderFns } from "./AnimatedForegroundBlock.vue?vue&type=template&id=5bbe6065&name=animated-foreground-block&"
import script from "./AnimatedForegroundBlock.vue?vue&type=script&lang=js&"
export * from "./AnimatedForegroundBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports